var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 9.5,
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#CBD5E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H20.01M14 17.2L14 21.6745C14 22.1637 14 22.4083 14.0553 22.6385C14.1043 22.8425 14.1851 23.0376 14.2947 23.2166C14.4184 23.4184 14.5914 23.5914 14.9373 23.9373L22.6059 31.6059C23.7939 32.7939 24.388 33.388 25.0729 33.6105C25.6755 33.8063 26.3245 33.8063 26.927 33.6105C27.612 33.388 28.2061 32.7939 29.3941 31.6059L31.6059 29.3941C32.7939 28.2061 33.388 27.612 33.6105 26.927C33.8063 26.3245 33.8063 25.6755 33.6105 25.0729C33.388 24.388 32.7939 23.7939 31.6059 22.6059L23.9373 14.9373C23.5914 14.5914 23.4184 14.4184 23.2166 14.2947C23.0376 14.1851 22.8425 14.1043 22.6385 14.0553C22.4083 14 22.1637 14 21.6745 14L17.2 14C16.0799 14 15.5198 14 15.092 14.218C14.7157 14.4097 14.4097 14.7157 14.218 15.092C14 15.5198 14 16.0799 14 17.2ZM20.5 20C20.5 20.2761 20.2761 20.5 20 20.5C19.7239 20.5 19.5 20.2761 19.5 20C19.5 19.7239 19.7239 19.5 20 19.5C20.2761 19.5 20.5 19.7239 20.5 20Z",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIco);
export default __webpack_public_path__ + "static/media/featured-ico.a3afd99632de27b419a3a4477987a181.svg";
export { ForwardRef as ReactComponent };